
riot.tag2('products-types-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Тип товара</div>\n    </yield>\n    <yield to="body">\n      <loader if="{loader}"></loader>\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="name" value="{item.name}">\n          <div class="help-block">{error.name}</div>\n        </div>\n        <div class="h4">Параметры</div>\n        <div class="alert alert-danger" if="{error.features}">{error.features}</div>\n        <catalog-static name="features" rows="{item.features}" cols="{cols}" dblclick="{parent.opts.submit.bind(this)}" add="{add}" remove="true">\n          <yield to="body">\n            <datatable-cell name="name">{row.name}</datatable-cell>\n          </yield>\n        </catalog-static>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];
    modal.loader = opts.id;
    modal.error = false;
    modal.item = {};
    modal.cols = [{ name: "name", value: "Наименование" }];
    modal.mixin('validation');
    modal.mixin('change');

    modal.rules = {
        name: 'empty',
        features: {
            required: true,
            rules: [{
                type: 'minLength[1]',
                prompt: 'Добавьте хотя бы один элемент в список'
            }]
        }
    };

    modal.afterChange = function (e) {
        var name = e.target.name;
        delete modal.error[name];
        modal.error = (0, _extends3.default)({}, modal.error, modal.validation.validate(modal.item, modal.rules, name));
    };

    modal.add = function () {
        modals.create('parameters-list-select-modal', {
            type: 'modal-primary',
            submit: function submit() {
                modal.item.features = modal.item.features || [];

                var items = this.tags.catalog.tags.datatable.getSelectedRows();
                var ids = modal.item.features.map(function (item) {
                    return item.id;
                });

                items.forEach(function (item) {
                    if (ids.indexOf(item.id) === -1) modal.item.features.push(item);
                });

                modal.update();
                this.modalHide();

                var event = document.createEvent('Event');
                event.initEvent('change', true, true);
                modal.tags.features.root.dispatchEvent(event);
            }
        });
    };

    if (opts.id) {
        API.request({
            object: 'ProductType',
            method: 'Info',
            data: { id: opts.id },
            success: function success(response) {
                modal.item = response;
            },
            complete: function complete() {
                modal.loader = false;
                modal.update();
            }
        });
    }
});
});


// WEBPACK FOOTER //
// ./pages/products/products-types/products-types-edit-modal.tag